var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7891 7.00003L3.61906 7.00003L8.49906 2.12003C8.88906 1.73003 8.88906 1.09003 8.49906 0.70003C8.10906 0.310029 7.47906 0.310029 7.08906 0.70003L0.499062 7.29003C0.109062 7.68003 0.109062 8.31003 0.499062 8.70003L7.07906 15.3C7.46906 15.69 8.09906 15.69 8.48906 15.3C8.87906 14.91 8.87906 14.28 8.48906 13.89L3.61906 9.00003L14.7891 9.00003C15.3391 9.00003 15.7891 8.55003 15.7891 8.00003C15.7891 7.45003 15.3391 7.00003 14.7891 7.00003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.9a2243bb2fef3e43bce0b9a8c9599976.svg";
export { ForwardRef as ReactComponent };